import React from 'react';
import defaultLogo from 'assets/icons/logo.png';
import { useBranding } from 'modules/App/hooks/useBranding';

// Mandatory attribution for the compact embedded portal widget.
//
// Fixpack item 17 (locked decision): whitelabel keeps this attribution mark
// mandatory, branded as "Powered by {brand.name}" — logo, name, and link all
// follow the viewing (deployment/whitelabel) brand. The public payload carries
// no attribution field, so the href is the brand's own website.
export default function SupplierPublicAttribution({ className }) {
  const brand = useBranding();
  return (
    <a
      href={brand.websiteUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      <span className="text-[8px] uppercase tracking-[0.18em] font-semibold text-slate-400">
        Powered by
      </span>
      <img
        src={brand.logoUrl || defaultLogo}
        alt={`${brand.name} logo`}
        className="h-3.5 w-auto object-contain"
        draggable={false}
      />
    </a>
  );
}
